// Used in: src/components/slash-command-menu.tsx, src/components/message-input.tsx
//
// The `SlashCommand` type is owned by @ringg/core — re-exported here so the
// ported components keep their original import path; only the pure
// `filterSlashCommands` helper lives locally (verbatim from agents-cdn).

import type { SlashCommand } from "@ringg/core";

export type { SlashCommand, SlashCommandToolType } from "@ringg/core";

export function filterSlashCommands(commands: SlashCommand[], query: string): SlashCommand[] {
  if (!query.startsWith("/")) return [];
  const search = query.slice(1).toLowerCase();
  if (!search) return commands;
  return commands.filter(
    (cmd) => cmd.command.slice(1).toLowerCase().includes(search) || cmd.display_name.toLowerCase().includes(search),
  );
}
